Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;
exports['default'] = makeIcon;

var _airbnbPropTypes = require('airbnb-prop-types');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../themes/withStyles');

var _isAmp = require('../utils/isAmp');

var _isAmp2 = _interopRequireDefault(_isAmp);

var _iconSize = require('../utils/propTypes/iconSize');

var _iconSize2 = _interopRequireDefault(_iconSize);

var _a11yIconProps = require('../utils/propTypes/a11yIconProps');

var _a11yIconProps2 = _interopRequireDefault(_a11yIconProps);

var _accessibilityLabel = require('../utils/propTypes/accessibilityLabel');

var _accessibilityLabel2 = _interopRequireDefault(_accessibilityLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = exports.propTypes = Object.assign({}, _a11yIconProps2['default'], {
  size: _iconSize2['default'],
  color: _propTypes2['default'].string,
  inline: _propTypes2['default'].bool
});

// note(maja): we intentionally use the non-directional global css import here
// for two reasons. (1) we do not want to wrap Icon in withStyles for performance
// reasons and (2) we need to use the css method so as to convert to classnames
// (from inline styles) for Amp.
// eslint-disable-next-line no-restricted-imports


var labelRequiredPropType = {
  accessibilityLabel: _accessibilityLabel2['default'].isRequired
};

var finalPropTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, propTypes));

var defaultProps = exports.defaultProps = {
  size: '1em',
  color: 'currentColor',
  inline: false
};

function makeIcon(Glyph, name) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$allowColorin = options.allowColoring,
      allowColoring = _options$allowColorin === undefined ? true : _options$allowColorin,
      _options$defaultFillC = options.defaultFillColor,
      defaultFillColor = _options$defaultFillC === undefined ? null : _options$defaultFillC,
      _options$labelRequire = options.labelRequired,
      labelRequired = _options$labelRequire === undefined ? false : _options$labelRequire;


  function AnIcon(_ref) {
    var accessibilityLabel = _ref.accessibilityLabel,
        decorative = _ref.decorative,
        fill = _ref.color,
        size = _ref.size,
        inline = _ref.inline;

    return Glyph(Object.assign({}, Glyph.defaultProps, { // this is only needed because we do Glyph() instead of <Glyph>
      role: decorative ? 'presentation' : 'img'
    }, decorative && { 'aria-hidden': true }, accessibilityLabel && { 'aria-label': accessibilityLabel }, !(0, _isAmp2['default'])() && { focusable: 'false' }, (0, _withStyles.css)(Object.assign({
      height: size,
      width: size
    }, !inline && { display: 'block' }, allowColoring && { fill: fill }))));
  }

  AnIcon.displayName = name;
  AnIcon.propTypes = Object.assign({}, finalPropTypes, labelRequired && labelRequiredPropType);
  AnIcon.defaultProps = Object.assign({}, defaultProps, allowColoring && defaultFillColor && { color: defaultFillColor });

  return AnIcon;
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/makeIcon.js
// module id = 22
// module chunks = 168707334958949